import { Controller } from "@hotwired/stimulus"
import NativeBridge from "../lib/native_bridge"

/**
 * Demo Login Controller
 * Shows demo login button only on iOS Turbo Native app (App Store review)
 * Hides on Android and web browsers for security
 *
 * Usage:
 *   <button data-controller="demo-login">Demo Login</button>
 *
 * The button will be hidden unless:
 * - Running in iOS Turbo Native app (User-Agent contains "Turbo Native iOS")
 * - AND DEMO_ACCOUNT_ENABLED=true on server (button rendered by server)
 */
export default class extends Controller {
  connect() {
    // Only show on iOS native app (App Store review)
    // Hide on Android and web browsers
    if (!NativeBridge.isIOS()) {
      this.element.style.display = "none"
    }
  }
}
